import { useEffect } from "react";
import Services from "../components/Services";
import CtaBanner from "../components/CtaBanner";

const ServiciiPage = () => {
  useEffect(() => {
    document.title = "Servicii | MEDAS Stomatologie Timișoara";
  }, []);

  return (
    <div className="pt-[76px] md:pt-[112px]">
      <Services />
      <CtaBanner />
    </div>
  );
};

export default ServiciiPage;
